import { render, staticRenderFns } from "./InvoicePaymentPage.vue?vue&type=template&id=8adbf884"
import script from "./InvoicePaymentPage.vue?vue&type=script&lang=js"
export * from "./InvoicePaymentPage.vue?vue&type=script&lang=js"
import style0 from "./InvoicePaymentPage.vue?vue&type=style&index=0&id=8adbf884&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports